import { HelpOutline } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import * as Styles from './UITooltip.styles';
import { UITooltipProps } from './UITooltip.types';

const UITooltip = ({
  title,
  color = 'info',
  arrow = false,
  placement = 'bottom-end',
  children,
  open,
}: UITooltipProps) => {
  return (
    <Styles.CustomTooltip
      title={title}
      color={color}
      arrow={arrow}
      placement={placement}
      sx={{ opacity: 0.85 }}
      enterTouchDelay={0}
      leaveDelay={3500}
      {...(open !== undefined ? { open } : {})}
    >
      {children ?? (
        <IconButton size="small" color={color}>
          {children ?? <HelpOutline fontSize="small" />}
        </IconButton>
      )}
    </Styles.CustomTooltip>
  );
};

export default UITooltip;
